<base-modal class="base-modal" [title]="title" [isProfileMode]="isProfileMode">
  <student-supports-panel-list
    [student]="student"
    [batchActionsMode$]="batchActionsMode$"
    [fociKey]="fociKey"
  ></student-supports-panel-list>
</base-modal>
